module.exports = "/_next/static/images/125544c94f1453e1b23287d2e9e4886d-man-holding-device-2@2x.jpg.webp";